import React from 'react';

import { colors } from '@/src/components/common/Avatar/Config';
import { cn } from '@/src/util/ui';

const UserAvatar = ({
  avatar,
  name,
  position,
  id,
  className,
}: {
  avatar: string;
  name: string;
  position: string;
  id?: string;
  className?: string;
}) => {
  const employeeInitials = name
    .split(' ') // Split the name into words
    .filter((word, index, array) => index === 0 || index === array.length - 1) // Only keep first and last word
    .map((word) => word.charAt(0).toUpperCase()) // Get the first letter of each word and capitalize
    .join(''); // Join the letters

  const backgroundColor = colors[employeeInitials.charAt(0)];
  const displayPhoto =
    avatar === null || avatar === '' ? 'default.png' : avatar;

  return (
    <>
      {name !== 'None' ? (
        <div
          style={{
            backgroundColor: backgroundColor,
            cursor: 'pointer',
            ...(className ? {} : { width: '29px', height: '29px' }),
          }}
          className={cn(
            'tw-w-[29px] tw-min-w-[29px] tw-h-[29px] tw-overflow-hidden',
            'tw-rounded-full tw-flex tw-justify-center tw-items-center tw-text-white tw-text-[12px] tw-font-brandonTextMedium',
            className
          )}
          data-tooltip-id={`assignee_avatar_tooltip_${id || ''}`}
          data-tooltip-html={`
      <div class="tw-flex tw-flex-col tw-gap-[5px]">
          <div 
              style="width: 180px; height: 140px; background-color: ${backgroundColor}; font-size: 100px"
              class="tw-font-brandonTextMedium tw-text-white tw-flex tw-justify-center tw-items-center tw-overflow-hidden">
              ${employeeInitials}
          </div>
          <div class="tw-flex tw-flex-col tw-text-cfo-black tw-text-center tw-max-w-[180px]">
              <span class="tw-text-[14px] tw-font-brandonTextMedium">${name}</span>
              <span class="tw-text-[12px]">${position}</span>
          </div>
      </div>`}
        >
          {employeeInitials}
        </div>
      ) : (
        <img
          src={`/api/file/profile_pictures/${displayPhoto}`}
          alt={`${name} profile`}
          className={cn(
            'tw-rounded-full tw-object-cover tw-object-center',
            className
          )}
          style={{
            ...(className ? {} : { width: '29px', height: '29px' }),
            cursor: 'pointer',
          }}
          data-tooltip-id={`assignee_avatar_tooltip_${id || ''}`}
          data-tooltip-html={`
            <div class="tw-flex tw-flex-col tw-gap-[5px]">
                <img 
                    src="/api/file/profile_pictures/${displayPhoto}" 
                    style="width: 180px; height: 140px; object-fit: cover; object-position: center;">
                <div class="tw-flex tw-flex-col tw-text-cfo-black tw-text-center">
                    <span class="tw-text-[14px] tw-font-brandonTextMedium">${name}</span>
                    <span class="tw-text-[12px]">${position}</span>
                </div>
            </div>`}
        />
      )}
    </>
  );
};

export default UserAvatar;
